import React from 'react';
import i18n from '../../i18n/i18n.js';
import { Link } from "react-router-dom";
import Form from '../../components/Forms/Form/Form';
import { NavigateTo, Utils } from '../../Utils.js';

import './AccountCreate.css'; 
 
class AccountCreate extends React.Component {
  
  state = {
    redirect: false,
  };   

  /**
   * Form hívja meg ha sikeresen lefutott a handle_submit()
   * ha nincs szükség erre a fv.-re akkor lehet törölni
   */
  on_submit_success(params = {formData: {}, result: {}}) {
    // frontend bejelentkezés és betöltő képernyő kikapcsolása
    if (typeof params.result.is_signed !== 'undefined' && parseInt(params.result.is_signed) === 1 && !window.AppRef.current.get_is_signed())
    {

      this.setState({redirect:true},()=>{
        window.AppRef.current.setState({is_signed: 1, login_ready: 1, user_data: params.result.user_data});

        if(window.AppHeaderRef?.current){ 
          window.AppHeaderRef.current.setState({signed:1});
        }
        
        if(window.modals.ProfileMenuRef?.current){ 
          window.modals.ProfileMenuRef.current.setState({is_signed:1});
        }
      });
    }
  }

  render() { 
 
    if (this.state.redirect===true){return <NavigateTo toURL='/'></NavigateTo>}

    return <div className={`container page_account_create`}>
      <div className="content">
       
        <div className="form_wrapper"> 
            <h2>{i18n.t('accountCreateTitle')}</h2>

            {/*<p>{i18n.t('lostPasswordText')}</p>*/}

            <Form name="account_create" submit_text={i18n.t('accountCreateSubmit')} parent={this} />

            {/*<Link data-type="in_app" className="sign_in" to="/sign_in">{i18n.t('accountCreateLogin')}</Link>*/}

          </div>
      </div>
    </div>;
  }

}

export default AccountCreate;